import React from "react"
import { ButtonBase, Tooltip } from "@mui/material"

import { dsColorNew } from "@palette"


// "+N" after the first item of a compact list; opens the list's "Show all" dialog
export default function AppMoreCount({ count, onClick }) {
	if (!count) return null

	return <Tooltip title="Show all" arrow>
		<ButtonBase
			onClick={onClick}
			sx={{
				ml: 0.75, px: 0.75, py: 0.25, borderRadius: '6px', fontSize: 12, fontWeight: 600, color: dsColorNew.appBlue,
				'&:hover': { backgroundColor: dsColorNew.pillActiveBg },
			}}
		>
			+{count}
		</ButtonBase>
	</Tooltip>
}
